export const RSACAF_LESSONS_PT = [
  {
    id: 'rsacaf-1',
    numero: 1,
    titre: "O RSA — compreender e pedir",
    sousTitre: "Os seus direitos, o seu dinheiro",
    contexte: "O seu rendimento é baixo ou inexistente. O RSA existe para o ajudar — mas 30% das pessoas com direito não o pedem.",
    explication: [
      "**O RSA** (Rendimento de Solidariedade Activa) é uma ajuda mensal paga pela CAF a pessoas sem recursos suficientes, a partir dos 25 anos.",
      "**O montante** em 2026: cerca de 635€/mês para uma pessoa sozinha. Varia conforme a situação familiar e os rendimentos.",
      "**Simulação gratuita**: aceda a caf.fr ou mesaides.gouv.fr — resultado em 5 minutos, anónimo e sem compromisso.",
      "**Para fazer o pedido**: entre em caf.fr → 'Os meus serviços online' → 'Fazer um pedido de RSA'. Documentos necessários: documento de identidade, RIB, comprovativo de morada, extratos bancários dos últimos 3 meses.",
      "**Se retomar o trabalho**: o RSA diminui gradualmente — não para de repente. Comunique os novos rendimentos à CAF.",
    ],
    question: "Pensa ter direito ao RSA. Qual é o primeiro passo?",
    options: [
      { id: 'a', text: "Fazer uma simulação gratuita em caf.fr ou mesaides.gouv.fr", correct: true },
      { id: 'b', text: "Dirigir-se directamente à CAF com todos os documentos", correct: false },
      { id: 'c', text: "Aguardar que a CAF entre em contacto", correct: false },
    ],
    explication_reponse: "A simulação é gratuita, anónima e sem compromisso. Dá uma estimativa em 5 minutos. Comece sempre por aqui — não tem nada a perder ao verificar os seus direitos.",
  },
  {
    id: 'rsacaf-2',
    numero: 2,
    titre: "Os abonos de família",
    sousTitre: "Apoios para famílias com filhos",
    contexte: "Tem filhos. A CAF paga várias ajudas consoante a sua situação — provavelmente mais do que imagina.",
    explication: [
      "**Os abonos de família clássicos**: pagos a partir de 2 filhos a cargo com menos de 20 anos. O montante depende dos seus rendimentos.",
      "**O subsídio de nascimento**: cerca de 1000€ pagos no 7º mês de gravidez, sujeito a condições de recursos. Comunique a gravidez à CAF antes do 3º mês.",
      "**O abono de base PAJE**: ajuda mensal desde o nascimento até aos 3 anos da criança, sujeito a condições de recursos.",
      "**O complemento de livre escolha do modo de guarda**: ajuda se o seu filho for guardado por uma ama ou creche aprovada.",
      "**Ferramenta indispensável**: caf.fr → 'Simular os meus direitos' para ter uma estimativa completa de todos os apoios a que tem direito.",
    ],
    question: "Está grávida. Quando deve comunicar à CAF?",
    options: [
      { id: 'a', text: "Antes do fim do 3º mês de gravidez", correct: true },
      { id: 'b', text: "No nascimento da criança", correct: false },
      { id: 'c', text: "Em qualquer altura, não há prazo", correct: false },
    ],
    explication_reponse: "Declarar a gravidez antes do 3º mês activa todos os apoios. Cada mês de atraso pode fazer perder direitos — o subsídio de nascimento é pago no 7º mês, por isso é preciso ter declarado antes.",
  },
  {
    id: 'rsacaf-3',
    numero: 3,
    titre: "Declarar rendimentos e alterações",
    sousTitre: "A cada trimestre e a cada evento",
    contexte: "A CAF precisa de ser informada da sua situação em tempo real. Esquecer uma declaração pode bloquear os seus apoios ou criar uma dívida.",
    explication: [
      "**A declaração trimestral RSA**: obrigatória de 3 em 3 meses (Janeiro, Abril, Julho, Outubro). Se se esquecer, o pagamento é suspenso — não perdido.",
      "**As alterações a declarar em 30 dias**: mudança de morada, nascimento, separação, retomar ou perder emprego, alteração de rendimentos.",
      "**Como declarar**: em caf.fr → 'A minha conta' → 'Comunicar uma alteração' ou directamente pela aplicação CAF Mon Compte.",
      "**O indevido**: se não declarar e continuar a receber apoios a que já não tem direito, a CAF pedirá o reembolso de tudo.",
      "**Separação**: cada progenitor abre o seu próprio processo na CAF. Os abonos vão para o progenitor com a guarda principal.",
    ],
    question: "Esqueceu-se da declaração trimestral RSA. O que acontece?",
    options: [
      { id: 'a', text: "O pagamento é suspenso até declarar — não é perdido definitivamente", correct: true },
      { id: 'b', text: "Perde definitivamente o RSA deste trimestre", correct: false },
      { id: 'c', text: "A CAF faz a declaração automaticamente", correct: false },
    ],
    explication_reponse: "Não entre em pânico se se esquecer — assim que fizer a declaração, o pagamento retoma. Coloque um lembrete no telemóvel: Janeiro, Abril, Julho, Outubro.",
  },
  {
    id: 'rsacaf-4',
    numero: 4,
    titre: "Utilizar o espaço CAF online",
    sousTitre: "Gerir tudo sem sair de casa",
    contexte: "O espaço CAF em caf.fr permite gerir tudo a partir de casa — declarações, pagamentos, mensagens, documentos.",
    explication: [
      "**Crie a sua conta** em caf.fr com o seu número de beneficiário (nas suas cartas da CAF) e data de nascimento.",
      "**O que pode fazer**: consultar os seus pagamentos, descarregar os seus comprovativos, enviar documentos, comunicar alterações, simular direitos.",
      "**O comprovativo CAF** prova os seus direitos — pedido para a cantina, creche, habitação social. Descarregável em 30 segundos em caf.fr.",
      "**A mensagem CAF**: envie documentos e questões directamente à sua CAF, sem espera telefónica nem deslocação.",
      "**A aplicação CAF Mon Compte**: notificações de pagamento, comprovativos, declarações trimestrais — tudo no telemóvel.",
    ],
    question: "A escola pede um comprovativo CAF para a cantina. Onde o encontrar rapidamente?",
    options: [
      { id: 'a', text: "Em caf.fr no seu espaço pessoal — descarregável em 30 segundos", correct: true },
      { id: 'b', text: "Deslocando-se à CAF com um documento de identidade", correct: false },
      { id: 'c', text: "Ligando para o 3230 e aguardando uma carta", correct: false },
    ],
    explication_reponse: "O comprovativo CAF descarrega-se instantaneamente em caf.fr ou na aplicação — disponível 24h/24. É um dos documentos mais úteis que deve ter sempre à mão.",
  },
];
